/* eslint-disable */
/* !!! THIS FILE WAS GENERATED BY GRAPHQL-CODE-GENERATOR !!!
* !!! DO NOT MODIFY THIS FILE BY YOURSELF  !!! */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Chat_DateScalar: string;
  CommerceV2_DateTime: string;
  CommerceV2_Price: string;
  DateTime: string;
  JSON: Record<string, any>;
  Voting_DateTime: string;
};

export type Chat_Chat = {
  __typename?: 'Chat_Chat';
  chatBans: Array<Chat_ChatBan>;
  /** An additional channel-specific list of words and phrases that are banned on exact match. */
  customBannedWords: Array<Scalars['String']>;
  /** Global default list of words and phrases that are banned on exact match. */
  exactMatchBannedWords: Array<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  /** Global default list of words and phrases that are banned on an exact or partial match. */
  partialMatchBannedWords: Array<Scalars['String']>;
  /** Whether the default global banned words list is enabled. */
  profanityFilterEnabled: Scalars['Boolean'];
};

export type Chat_ChatBan = {
  __typename?: 'Chat_ChatBan';
  createdAt: Scalars['Chat_DateScalar'];
  displayName?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['Chat_DateScalar']>;
  id: Scalars['ID'];
  userId: Scalars['ID'];
};

/** An event relating to a chat ban */
export type Chat_ChatBanEvent = {
  __typename?: 'Chat_ChatBanEvent';
  /** The chat ban associated with the event */
  chatBan: Chat_ChatBan;
  /** The ID of the event */
  id: Scalars['ID'];
  /** The type of event */
  type: Chat_ChatBanEventType;
};

export enum Chat_ChatBanEventType {
  ChatBanCreated = 'CHAT_BAN_CREATED',
  ChatBanDeleted = 'CHAT_BAN_DELETED'
}

/** An event relating to chat */
export type Chat_ChatEvent = {
  __typename?: 'Chat_ChatEvent';
  /** The chat associated with the event */
  chat: Chat_Chat;
  /** The ID of the event */
  id: Scalars['ID'];
  /** The type of event */
  type: Chat_ChatEventType;
};

export enum Chat_ChatEventType {
  ChatUpdated = 'CHAT_UPDATED'
}

export type Chat_GrantResult = {
  __typename?: 'Chat_GrantResult';
  /** @deprecated Replaced with pubnubAccessToken */
  authKey?: Maybe<Scalars['String']>;
  hasWriteAccess: Scalars['Boolean'];
  isBanned: Scalars['Boolean'];
  pubnubAccessToken: Scalars['String'];
  roomKey: Scalars['String'];
  userId: Scalars['ID'];
};

/** Represents a Plugin Instance for a given Channel */
export type Chat_Instance = {
  __typename?: 'Chat_Instance';
  channelId: Scalars['ID'];
  id: Scalars['ID'];
  publicChat: Chat_Chat;
};

export enum CommerceV2_CommerceProvider {
  Target = 'Target'
}

export type CommerceV2_CreatePreselectedVariantMappingInput = {
  productId: Scalars['ID'];
  variantId: Scalars['ID'];
};

export type CommerceV2_CreateSaleInput = {
  preselectedVariantMappings?: InputMaybe<Array<CommerceV2_CreatePreselectedVariantMappingInput>>;
  productIds: Array<Scalars['ID']>;
  title: Scalars['String'];
};

/** Represents an ISO 4217 Currency Code: https://en.wikipedia.org/wiki/ISO_4217 */
export enum CommerceV2_CurrencyCode {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Czk = 'CZK',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gmd = 'GMD',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Isk = 'ISK',
  Jep = 'JEP',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltl = 'LTL',
  Lvl = 'LVL',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Srd = 'SRD',
  Std = 'STD',
  Syp = 'SYP',
  Thb = 'THB',
  Tmt = 'TMT',
  Tnd = 'TND',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW'
}

export type CommerceV2_Image = {
  __typename?: 'CommerceV2_Image';
  altText?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CommerceV2_Instance = CommerceV2_Node & {
  __typename?: 'CommerceV2_Instance';
  activeSale?: Maybe<CommerceV2_Sale>;
  activeSaleId?: Maybe<Scalars['ID']>;
  channelId: Scalars['ID'];
  createdAt: Scalars['CommerceV2_DateTime'];
  id: Scalars['ID'];
  paymentSettings: CommerceV2_PaymentSettings;
  provider: CommerceV2_CommerceProvider;
  sales: CommerceV2_SalePage;
  updatedAt: Scalars['CommerceV2_DateTime'];
};


export type CommerceV2_InstanceSalesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

/** Base class for global object identification */
export type CommerceV2_Node = {
  id: Scalars['ID'];
};

export type CommerceV2_PaymentSettings = {
  __typename?: 'CommerceV2_PaymentSettings';
  currencyCode: CommerceV2_CurrencyCode;
};

export type CommerceV2_PreselectedVariantMapping = CommerceV2_Node & {
  __typename?: 'CommerceV2_PreselectedVariantMapping';
  /** The timestamp when the mapping was created */
  createdAt: Scalars['CommerceV2_DateTime'];
  /** The ID of the mapping */
  id: Scalars['ID'];
  /** The Product ID of the mapping */
  productId: Scalars['String'];
  /** The timestamp when the mapping was updated */
  updatedAt: Scalars['CommerceV2_DateTime'];
  /** The Variant ID of the mapping */
  variantId: Scalars['String'];
};

export type CommerceV2_PriceRange = {
  __typename?: 'CommerceV2_PriceRange';
  maxVariantPrice: Scalars['CommerceV2_Price'];
  minVariantPrice: Scalars['CommerceV2_Price'];
};

export type CommerceV2_Product = CommerceV2_Node & {
  __typename?: 'CommerceV2_Product';
  available: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<CommerceV2_Image>;
  id: Scalars['ID'];
  /** Product property names like "Size", "Color", and "Material". Variants are based on permutations of these options */
  options: Array<CommerceV2_ProductOptions>;
  preselectedVariant: CommerceV2_ProductVariant;
  priceRange: CommerceV2_PriceRange;
  title: Scalars['String'];
  totalInventory?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  variants: Array<CommerceV2_ProductVariant>;
};

export type CommerceV2_ProductOption = {
  __typename?: 'CommerceV2_ProductOption';
  name: Scalars['String'];
  previewImage?: Maybe<CommerceV2_Image>;
  value: Scalars['String'];
};

export type CommerceV2_ProductOptions = {
  __typename?: 'CommerceV2_ProductOptions';
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type CommerceV2_ProductVariant = CommerceV2_Node & {
  __typename?: 'CommerceV2_ProductVariant';
  available: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<CommerceV2_Image>;
  id: Scalars['ID'];
  images: Array<CommerceV2_Image>;
  options: Array<CommerceV2_ProductOption>;
  price: Scalars['CommerceV2_Price'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type CommerceV2_Sale = CommerceV2_Node & {
  __typename?: 'CommerceV2_Sale';
  /** The timestamp when the Sale was created */
  createdAt: Scalars['CommerceV2_DateTime'];
  /** The Product ID which is featured in the Player */
  featuredProductId?: Maybe<Scalars['String']>;
  /** Indicates if the Sale is hidden */
  hidden: Scalars['Boolean'];
  /** The ID of the Sale */
  id: Scalars['ID'];
  /** The the parent Instance of the Sale */
  instance: CommerceV2_Instance;
  /** The preselected variant mappings for Products in the Sale */
  preselectedVariantMappings: Array<CommerceV2_PreselectedVariantMapping>;
  /** Resolve a product in the context of a Sale */
  product?: Maybe<CommerceV2_Product>;
  /** The Product IDs belonging to the Sale */
  productIds: Array<Scalars['ID']>;
  /** The Products in the Sale */
  products: Array<CommerceV2_Product>;
  /** The title of the Sale */
  title: Scalars['String'];
  /** The timestamp when the Sale was last updated */
  updatedAt: Scalars['CommerceV2_DateTime'];
  /** The subset of Product IDs which are visible in the Player */
  visibleProductIds: Array<Scalars['ID']>;
};


export type CommerceV2_SaleProductArgs = {
  id: Scalars['ID'];
};

export type CommerceV2_SaleEvent = CommerceV2_Node & {
  __typename?: 'CommerceV2_SaleEvent';
  /** The ID of the event */
  id: Scalars['ID'];
  /** The Sale associated with the event */
  sale: CommerceV2_Sale;
  /** The type of the event */
  type: CommerceV2_SaleEventType;
};

export enum CommerceV2_SaleEventType {
  SaleCreated = 'SALE_CREATED',
  SaleDeleted = 'SALE_DELETED',
  SaleUpdated = 'SALE_UPDATED'
}

export type CommerceV2_SalePage = {
  __typename?: 'CommerceV2_SalePage';
  cursor?: Maybe<Scalars['String']>;
  moreData: Scalars['Boolean'];
  records: Array<CommerceV2_Sale>;
};

export type CommerceV2_UpdateSaleInput = {
  featuredProductId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  preselectedVariantMappings: Array<CommerceV2_CreatePreselectedVariantMappingInput>;
  productIds: Array<Scalars['ID']>;
  title: Scalars['String'];
  visibleProductIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type DisablePluginInput = {
  options?: InputMaybe<Scalars['JSON']>;
  /** Force the plugin to stay disabled at the start of any future broadcast */
  persistent?: InputMaybe<Scalars['Boolean']>;
  /** The unique key for the plugin to enable */
  pluginKey: Scalars['String'];
};

export type DisablePluginsInput = {
  channelId?: InputMaybe<Scalars['ID']>;
  pluginKeys?: InputMaybe<Array<Scalars['String']>>;
  plugins?: InputMaybe<Array<DisablePluginInput>>;
};

export type EnablePluginInput = {
  forCurrentBroadcast?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Scalars['JSON']>;
  /** Force the plugin to stay enabled at the end of the broadcast */
  persistent?: InputMaybe<Scalars['Boolean']>;
  /** The unique key for the plugin to enable */
  pluginKey: Scalars['String'];
};

export type EnablePluginsInput = {
  broadcastId?: InputMaybe<Scalars['ID']>;
  channelId?: InputMaybe<Scalars['ID']>;
  plugins: Array<EnablePluginInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Bans a user from public chat */
  chat_banUserFromPublicChat: Chat_ChatBan;
  /** Unbans a user from public chat */
  chat_unbanUserFromPublicChat: Chat_ChatBan;
  /** Updates preferences for public chat */
  chat_updatePublicChatPreferences: Chat_Instance;
  commerceV2_activateSale: CommerceV2_Instance;
  /** Create a new sale */
  commerceV2_createSale: CommerceV2_Sale;
  commerceV2_deactivateSale: CommerceV2_Instance;
  /** Delete an existing sale */
  commerceV2_deleteSale?: Maybe<Scalars['ID']>;
  /** Update an existing sale */
  commerceV2_updateSale: CommerceV2_Sale;
  /** Update a sale's featured product */
  commerceV2_updateSaleFeaturedProduct: CommerceV2_Sale;
  /** Update a sale's product IDs */
  commerceV2_updateSaleProductIds: CommerceV2_Sale;
  /** Update a sale's title */
  commerceV2_updateSaleTitle: CommerceV2_Sale;
  /** Update a sale's visible product IDs */
  commerceV2_updateSaleVisibleProductIds: CommerceV2_Sale;
  /** Disable one or more plugins on a particular channel. */
  disablePlugins: Array<Plugin>;
  /** Enable one or more plugins on a particular channel. */
  enablePlugins: Array<Plugin>;
  /** Creates a shopping cart filled with the specified items */
  target_createCart: Scalars['String'];
  /** Update the current playback timing state. See the documentation for PlaybackTimingState for the parameter definitions. */
  updatePlaybackTiming: PlaybackTimingState;
  /** Update one or more plugins on a particular channel. */
  updatePlugins: Array<Plugin>;
  voting_activateQuestion: Scalars['Boolean'];
  voting_castVote: Scalars['Boolean'];
  voting_createQuestion?: Maybe<Voting_Question>;
  voting_deactivateQuestion: Scalars['Boolean'];
  voting_deleteQuestion: Scalars['String'];
  /** Resets votes for all questions */
  voting_resetAllVotes: Array<Voting_Question>;
  /** Resets votes for a question */
  voting_resetVotes: Voting_Question;
  voting_updateQuestion: Voting_Question;
};


export type MutationChat_BanUserFromPublicChatArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationChat_UnbanUserFromPublicChatArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type MutationChat_UpdatePublicChatPreferencesArgs = {
  customBannedWords?: InputMaybe<Array<Scalars['String']>>;
  profanityFilterEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCommerceV2_ActivateSaleArgs = {
  saleId: Scalars['ID'];
};


export type MutationCommerceV2_CreateSaleArgs = {
  input: CommerceV2_CreateSaleInput;
};


export type MutationCommerceV2_DeleteSaleArgs = {
  id: Scalars['String'];
};


export type MutationCommerceV2_UpdateSaleArgs = {
  input: CommerceV2_UpdateSaleInput;
};


export type MutationCommerceV2_UpdateSaleFeaturedProductArgs = {
  featuredProductId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationCommerceV2_UpdateSaleProductIdsArgs = {
  id: Scalars['ID'];
  productIds: Array<Scalars['ID']>;
};


export type MutationCommerceV2_UpdateSaleTitleArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationCommerceV2_UpdateSaleVisibleProductIdsArgs = {
  id: Scalars['ID'];
  visibleProductIds: Array<Scalars['ID']>;
};


export type MutationDisablePluginsArgs = {
  command: DisablePluginsInput;
};


export type MutationEnablePluginsArgs = {
  command: EnablePluginsInput;
};


export type MutationTarget_CreateCartArgs = {
  items: Array<Target_CreateCartInput>;
};


export type MutationUpdatePlaybackTimingArgs = {
  position?: InputMaybe<Scalars['Float']>;
  velocity?: InputMaybe<Scalars['Float']>;
};


export type MutationUpdatePluginsArgs = {
  command: UpdatePluginsInput;
};


export type MutationVoting_ActivateQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationVoting_CastVoteArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  questionId: Scalars['String'];
  votes: Array<Voting_VotesInput>;
};


export type MutationVoting_CreateQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  question: Voting_CreateQuestionInput;
};


export type MutationVoting_DeactivateQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type MutationVoting_DeleteQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationVoting_ResetAllVotesArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type MutationVoting_ResetVotesArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  questionId: Scalars['String'];
};


export type MutationVoting_UpdateQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  question: Voting_UpdateQuestionInput;
};

/** Represents the timing state of the current video playback. */
export type PlaybackTimingState = {
  __typename?: 'PlaybackTimingState';
  /** The current point of the current video playback, measured in milliseconds since the start of the video. */
  currentPosition: Scalars['Float'];
  /** The starting point of the current video playback, measured in milliseconds since the start of the video. */
  position: Scalars['Float'];
  /** When the timing state was last updated, measured in milliseconds since the epoch. */
  timestamp: Scalars['Float'];
  /** The rate of playback. A value of 1.0 indicates playback at normal speed, while 0 indicates a pause. */
  velocity: Scalars['Float'];
};

/** Represents an instance of Plugin for a Stage TEN Channel or Broadcast */
export type Plugin = {
  __typename?: 'Plugin';
  /** The unique ID of the Stage TEN Broadcast is plugin is active on */
  broadcastId?: Maybe<Scalars['ID']>;
  /** The unique ID of the Stage TEN Channel is plugin is associated with */
  channelId: Scalars['ID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Replaced with 'persistent' attribute */
  forCurrentBroadcast: Scalars['Boolean'];
  /** The plugin instance's unique ID */
  id: Scalars['ID'];
  options?: Maybe<Scalars['JSON']>;
  /** The plugin will stay enabled at the end of the broadcast */
  persistent: Scalars['Boolean'];
  /** The plugin's definition */
  pluginDefinition?: Maybe<PluginDefinition>;
  /** The current state of this plugin */
  state: PluginState;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Represents a Registered Plugin in the STAGE TEN Plugin Registry */
export type PluginDefinition = {
  __typename?: 'PluginDefinition';
  attributes?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultPersistence: Scalars['Boolean'];
  defaultState: PluginState;
  description: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  key: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Represents a list of PluginDefinitions */
export type PluginDefinitionList = {
  __typename?: 'PluginDefinitionList';
  cursor?: Maybe<Scalars['String']>;
  moreData: Scalars['Boolean'];
  pluginDefinitions?: Maybe<Array<PluginDefinition>>;
};

/** Represents an event that happens to a PluginInstance */
export type PluginEvent = {
  __typename?: 'PluginEvent';
  event: Scalars['String'];
  plugin: Plugin;
};

/** Represents a list of PluginInstances */
export type PluginList = {
  __typename?: 'PluginList';
  cursor?: Maybe<Scalars['String']>;
  moreData: Scalars['Boolean'];
  plugins?: Maybe<Array<Plugin>>;
};

/** The state of the plugin */
export enum PluginState {
  Disabled = 'disabled',
  Enabled = 'enabled'
}

export type Query = {
  __typename?: 'Query';
  chat_chatBans: Array<Chat_ChatBan>;
  /** Resolves the Instance associated with the access token and intializes a new Instance if it does not exist */
  chat_instance: Chat_Instance;
  /** Requests access to a channel's public chat */
  chat_publicChatAccess: Chat_GrantResult;
  /** Checks if display name is profane or restricted */
  chat_validateDisplayName: Scalars['Boolean'];
  commerceV2_instance?: Maybe<CommerceV2_Instance>;
  /** Query a product by its ID */
  commerceV2_product?: Maybe<CommerceV2_Product>;
  /** Query a list of products with a search term */
  commerceV2_products: Array<CommerceV2_Product>;
  /** Query a list of products with their IDs */
  commerceV2_productsByIds: Array<Maybe<CommerceV2_Product>>;
  /** Query a sale by its ID */
  commerceV2_sale?: Maybe<CommerceV2_Sale>;
  /** Query existing sales */
  commerceV2_sales: CommerceV2_SalePage;
  /** Get the current playback timing state. */
  playbackTiming?: Maybe<PlaybackTimingState>;
  /** Get a plugin instance by its interal UUID */
  plugin?: Maybe<Plugin>;
  /** Get a particular plugin definition by UUID */
  pluginDefinition?: Maybe<PluginDefinition>;
  /** Get a particular plugin definition by unique key */
  pluginDefinitionByKey?: Maybe<PluginDefinition>;
  /** Get a list of available plugins */
  pluginDefinitions?: Maybe<PluginDefinitionList>;
  /** Get a list of the plugins on a particular channel. */
  plugins: PluginList;
  /** Look up the details of a specific product */
  target_productDetails: Target_ProductDetails;
  /** Perform a keyword search for products */
  target_products: Array<Target_ProductDetails>;
  /** Returns the currently active question. */
  voting_activeQuestion?: Maybe<Voting_Question>;
  /** Resolves the Instance associated with the access token and intializes a new Instance if it does not exist */
  voting_instance: Voting_Instance;
  voting_question?: Maybe<Voting_Question>;
  voting_questionFeed: Voting_QuestionFeed;
  /** @deprecated Paginated endpoint questionFeed is preferred */
  voting_questions: Array<Voting_Question>;
};


export type QueryChat_ChatBansArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type QueryChat_InstanceArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type QueryChat_PublicChatAccessArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  requestWritePermission?: InputMaybe<Scalars['Boolean']>;
};


export type QueryChat_ValidateDisplayNameArgs = {
  displayName: Scalars['String'];
};


export type QueryCommerceV2_InstanceArgs = {
  channelId?: InputMaybe<Scalars['ID']>;
};


export type QueryCommerceV2_ProductArgs = {
  id: Scalars['ID'];
};


export type QueryCommerceV2_ProductsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QueryCommerceV2_ProductsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryCommerceV2_SaleArgs = {
  id: Scalars['ID'];
};


export type QueryCommerceV2_SalesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryPluginArgs = {
  id: Scalars['String'];
};


export type QueryPluginDefinitionArgs = {
  id: Scalars['String'];
};


export type QueryPluginDefinitionByKeyArgs = {
  pluginDefinitionKey: Scalars['String'];
};


export type QueryPluginDefinitionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryPluginsArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<PluginState>;
};


export type QueryTarget_ProductDetailsArgs = {
  tcin: Scalars['String'];
};


export type QueryTarget_ProductsArgs = {
  searchKeyword: Scalars['String'];
};


export type QueryVoting_ActiveQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type QueryVoting_InstanceArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type QueryVoting_QuestionArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type QueryVoting_QuestionFeedArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Voting_QuestionFeedOptions>;
};


export type QueryVoting_QuestionsArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** An event relating to a chat ban has occurred */
  chat_chatBanEvent: Chat_ChatBanEvent;
  /** Indicates if a GrantResult is updated. */
  chat_grantResultUpdated: Chat_GrantResult;
  /** An event relating to a public chat has occurred */
  chat_publicChatEvent: Chat_ChatEvent;
  /** Indicates that a sale has been activated, modified or deactivated */
  commerceV2_activeSaleUpdated?: Maybe<CommerceV2_Instance>;
  /** A sale has been created, updated or deleted */
  commerceV2_saleEvent: CommerceV2_SaleEvent;
  /** Subscribe to updates to the playback timing state. */
  playbackTimingUpdated: PlaybackTimingState;
  /** Indicates that an event has happened to a PluginInstance. */
  pluginEvent: PluginEvent;
  /** Indicates that the currently active question has been changed. */
  voting_activeQuestionUpdated?: Maybe<Voting_Question>;
  /** Indicates that a Question has been created. */
  voting_questionCreated: Voting_Question;
  /** Indicates that a Question has been deleted. */
  voting_questionDeleted: Voting_Question;
  /** Indicates that the Question or associated Answer data have been updated. */
  voting_questionUpdated: Voting_Question;
};


export type SubscriptionChat_GrantResultUpdatedArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type SubscriptionCommerceV2_ActiveSaleUpdatedArgs = {
  channelId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionPlaybackTimingUpdatedArgs = {
  maxIntervalMillis?: InputMaybe<Scalars['Float']>;
};


export type SubscriptionPluginEventArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionVoting_ActiveQuestionUpdatedArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionVoting_QuestionCreatedArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionVoting_QuestionDeletedArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionVoting_QuestionUpdatedArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};

/** Represents the items to add to a cart */
export type Target_CreateCartInput = {
  /** The number of items to add */
  quantity: Scalars['Int'];
  /** The TCIN of the item to add */
  tcin: Scalars['String'];
};

/** Target product details */
export type Target_ProductDetails = {
  __typename?: 'Target_ProductDetails';
  description?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tcin: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type UpdatePluginInput = {
  options: Scalars['JSON'];
  /** The unique key for the plugin to update */
  pluginKey: Scalars['String'];
};

export type UpdatePluginsInput = {
  channelId?: InputMaybe<Scalars['ID']>;
  plugins: Array<UpdatePluginInput>;
};

/** Represents a possible answer to a question */
export type Voting_Answer = {
  __typename?: 'Voting_Answer';
  /** The timestamp of when this Answer was created */
  createdAt: Scalars['Voting_DateTime'];
  id: Scalars['ID'];
  /** The array index, used for sorting */
  index: Scalars['Int'];
  /** Is this the correct answer for the question */
  isCorrect?: Maybe<Scalars['Boolean']>;
  /** The text of the answer to display to the end user */
  text: Scalars['String'];
  /** The timestamp of when this Answer was last updated */
  updatedAt: Scalars['Voting_DateTime'];
  /** The current number of votes for this answer */
  votes: Scalars['Int'];
};

/** Represents the styles for the answer result bars */
export type Voting_AnswerBarStyles = {
  __typename?: 'Voting_AnswerBarStyles';
  backgroundFill: Voting_Fill;
  cornerRadius?: Maybe<Scalars['Float']>;
  direction?: Maybe<Scalars['String']>;
  height: Scalars['Float'];
  margins: Scalars['Float'];
  padding: Scalars['Float'];
  resultFill: Voting_Fill;
  textFill: Voting_Fill;
  voteDisplayFormat?: Maybe<Scalars['String']>;
};

export type Voting_AnswerBarStylesInput = {
  backgroundFill: Voting_FillInput;
  cornerRadius?: InputMaybe<Scalars['Float']>;
  direction?: InputMaybe<Scalars['String']>;
  height: Scalars['Float'];
  padding: Scalars['Float'];
  resultFill: Voting_FillInput;
  textFill: Voting_FillInput;
  voteDisplayFormat?: InputMaybe<Scalars['String']>;
};

/** Represents a new answer to be created */
export type Voting_CreateAnswerInput = {
  isCorrect?: InputMaybe<Scalars['Boolean']>;
  text: Scalars['String'];
  votes?: InputMaybe<Scalars['Int']>;
};

/** Represents a new question to be created */
export type Voting_CreateQuestionInput = {
  /** The answers for this question */
  answers?: InputMaybe<Array<Voting_CreateAnswerInput>>;
  /** The ID of the answer that is the correct one */
  correctAnswerId?: InputMaybe<Scalars['ID']>;
  /** Does this question have a correct answer */
  hasCorrectAnswer?: InputMaybe<Scalars['Boolean']>;
  /** The number of votes each user may make for this question */
  maxVotesAllowed?: InputMaybe<Scalars['Int']>;
  /** The styles to apply on this Question when displayed to viewers */
  styles?: InputMaybe<Voting_CreateStylesInput>;
  /** The text of the question */
  text: Scalars['String'];
};

export type Voting_CreateStylesInput = {
  answerBarStyles: Array<Voting_AnswerBarStylesInput>;
  name: Scalars['String'];
  promptStyles: Voting_PromptStylesInput;
  resultStyles: Voting_ResultStylesInput;
  version: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

/** Represents a fill style */
export type Voting_Fill = {
  __typename?: 'Voting_Fill';
  alpha?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Int']>;
};

export type Voting_FillInput = {
  alpha?: InputMaybe<Scalars['Float']>;
  color?: InputMaybe<Scalars['Int']>;
};

/** Represents a Plugin Instance for a given Channel */
export type Voting_Instance = {
  __typename?: 'Voting_Instance';
  activeQuestionId?: Maybe<Scalars['ID']>;
  channelId: Scalars['ID'];
  id: Scalars['ID'];
  questionFeed: Voting_QuestionFeed;
  questions: Array<Voting_Question>;
};


/** Represents a Plugin Instance for a given Channel */
export type Voting_InstanceQuestionFeedArgs = {
  options?: InputMaybe<Voting_QuestionFeedOptions>;
};

/** Represents the prompt style for a question */
export type Voting_PromptStyles = {
  __typename?: 'Voting_PromptStyles';
  backgroundFill: Voting_Fill;
  cornerRadius: Scalars['Float'];
  padding: Scalars['Float'];
  textFill: Voting_Fill;
};

export type Voting_PromptStylesInput = {
  backgroundFill: Voting_FillInput;
  cornerRadius: Scalars['Float'];
  padding: Scalars['Float'];
  textFill: Voting_FillInput;
};

/** Represents a question */
export type Voting_Question = {
  __typename?: 'Voting_Question';
  /** The answers for this question */
  answers: Array<Voting_Answer>;
  /** The ID of the answer that is the correct one */
  correctAnswerId?: Maybe<Scalars['ID']>;
  /** The timestamp of when this Question was created */
  createdAt: Scalars['Voting_DateTime'];
  /** Does this question have a correct answer */
  hasCorrectAnswer?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** The Instance that this Question is associated with */
  instance?: Maybe<Voting_Instance>;
  /** The number of votes each user may make for this question */
  maxVotesAllowed?: Maybe<Scalars['Int']>;
  /** The styles to apply on this Question when displayed to viewers */
  styles?: Maybe<Voting_Styles>;
  /** The text of the question */
  text: Scalars['String'];
  /** The timestamp of when this Question was last updated */
  updatedAt: Scalars['Voting_DateTime'];
};

/** Represents a feed of Questions */
export type Voting_QuestionFeed = {
  __typename?: 'Voting_QuestionFeed';
  cursor?: Maybe<Scalars['String']>;
  moreData: Scalars['Boolean'];
  questions: Array<Voting_Question>;
};

/** Pagination options for Question feed */
export type Voting_QuestionFeedOptions = {
  cursor?: InputMaybe<Scalars['Voting_DateTime']>;
  /** Max number of elements per fetch. (Default: 10, Fetch all: -1) */
  limit: Scalars['Int'];
};

/** Represents the styles for the answer result bars */
export type Voting_ResultStyles = {
  __typename?: 'Voting_ResultStyles';
  backgroundFill: Voting_Fill;
  childGaps: Scalars['Float'];
  cornerRadius: Scalars['Float'];
  direction?: Maybe<Scalars['String']>;
  padding: Scalars['Float'];
  topMargin?: Maybe<Scalars['Float']>;
};

export type Voting_ResultStylesInput = {
  backgroundFill: Voting_FillInput;
  childGaps: Scalars['Float'];
  cornerRadius: Scalars['Float'];
  direction: Scalars['String'];
  padding: Scalars['Float'];
  topMargin: Scalars['Float'];
};

/** Represents the Overlay Styles for a question */
export type Voting_Styles = {
  __typename?: 'Voting_Styles';
  answerBarStyles: Array<Voting_AnswerBarStyles>;
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  promptStyles: Voting_PromptStyles;
  resultStyles: Voting_ResultStyles;
  version: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

/** Represents an update to a specific answer */
export type Voting_UpdateAnswerInput = {
  id?: InputMaybe<Scalars['ID']>;
  isCorrect?: InputMaybe<Scalars['Boolean']>;
  text: Scalars['String'];
  votes?: InputMaybe<Scalars['Int']>;
};

export type Voting_UpdateQuestionInput = {
  /** The answers for this question */
  answers?: InputMaybe<Array<Voting_UpdateAnswerInput>>;
  /** The ID of the answer that is the correct one */
  correctAnswerId?: InputMaybe<Scalars['ID']>;
  /** Does this question have a correct answer */
  hasCorrectAnswer?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** The number of votes each user may make for this question */
  maxVotesAllowed?: InputMaybe<Scalars['Int']>;
  /** The styles to apply on this Question when displayed to viewers */
  styles?: InputMaybe<Voting_UpdateStylesInput>;
  /** The text of the question */
  text: Scalars['String'];
};

export type Voting_UpdateStylesInput = {
  answerBarStyles: Array<Voting_AnswerBarStylesInput>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  promptStyles: Voting_PromptStylesInput;
  resultStyles: Voting_ResultStylesInput;
  version: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type Voting_VotesInput = {
  answerId: Scalars['ID'];
  count: Scalars['Int'];
};

export type BaseSaleFragment = { __typename?: 'CommerceV2_Sale', id: string, title: string };

export type SaleFragment = { __typename?: 'CommerceV2_Sale', featuredProductId?: string | null, productIds: Array<string>, visibleProductIds: Array<string>, id: string, title: string, products: Array<{ __typename?: 'CommerceV2_Product', id: string, available: boolean, title: string, priceRange: { __typename?: 'CommerceV2_PriceRange', maxVariantPrice: string, minVariantPrice: string }, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, preselectedVariant: { __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> }, variants: Array<{ __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> }>, options: Array<{ __typename?: 'CommerceV2_ProductOptions', name: string, values: Array<string> }> }> };

export type PaymentSettingsFragment = { __typename?: 'CommerceV2_PaymentSettings', currencyCode: CommerceV2_CurrencyCode };

export type PriceRangeFragment = { __typename?: 'CommerceV2_PriceRange', maxVariantPrice: string, minVariantPrice: string };

export type InstanceFragment = { __typename?: 'CommerceV2_Instance', id: string, activeSale?: { __typename?: 'CommerceV2_Sale', featuredProductId?: string | null, productIds: Array<string>, visibleProductIds: Array<string>, id: string, title: string, products: Array<{ __typename?: 'CommerceV2_Product', id: string, available: boolean, title: string, priceRange: { __typename?: 'CommerceV2_PriceRange', maxVariantPrice: string, minVariantPrice: string }, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, preselectedVariant: { __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> }, variants: Array<{ __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> }>, options: Array<{ __typename?: 'CommerceV2_ProductOptions', name: string, values: Array<string> }> }> } | null, paymentSettings: { __typename?: 'CommerceV2_PaymentSettings', currencyCode: CommerceV2_CurrencyCode } };

export type ImageFragment = { __typename?: 'CommerceV2_Image', altText?: string | null, url: string };

export type ProductVariantFragment = { __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> };

export type ProductOptionFragment = { __typename?: 'CommerceV2_ProductOption', name: string, value: string };

export type ProductOptionsFragment = { __typename?: 'CommerceV2_ProductOptions', name: string, values: Array<string> };

export type BaseProductFragment = { __typename?: 'CommerceV2_Product', id: string, available: boolean, title: string };

export type ProductFragment = { __typename?: 'CommerceV2_Product', id: string, available: boolean, title: string, priceRange: { __typename?: 'CommerceV2_PriceRange', maxVariantPrice: string, minVariantPrice: string }, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, preselectedVariant: { __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> }, variants: Array<{ __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> }>, options: Array<{ __typename?: 'CommerceV2_ProductOptions', name: string, values: Array<string> }> };

export type ProductHighlightFragment = { __typename?: 'CommerceV2_Product', id: string, available: boolean, title: string, priceRange: { __typename?: 'CommerceV2_PriceRange', maxVariantPrice: string, minVariantPrice: string }, preselectedVariant: { __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> }, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null };

export type GetActiveSaleHighlightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveSaleHighlightsQuery = { __typename?: 'Query', commerceV2_instance?: { __typename?: 'CommerceV2_Instance', id: string, activeSale?: { __typename?: 'CommerceV2_Sale', featuredProductId?: string | null, productIds: Array<string>, visibleProductIds: Array<string>, id: string, title: string, products: Array<{ __typename?: 'CommerceV2_Product', id: string, available: boolean, title: string, priceRange: { __typename?: 'CommerceV2_PriceRange', maxVariantPrice: string, minVariantPrice: string }, preselectedVariant: { __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> }, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null }> } | null, paymentSettings: { __typename?: 'CommerceV2_PaymentSettings', currencyCode: CommerceV2_CurrencyCode } } | null };

export type ActiveSaleHighlightsUpdatedSubscriptionVariables = Exact<{
  channelId: Scalars['ID'];
}>;


export type ActiveSaleHighlightsUpdatedSubscription = { __typename?: 'Subscription', commerceV2_activeSaleUpdated?: { __typename?: 'CommerceV2_Instance', id: string, activeSale?: { __typename?: 'CommerceV2_Sale', featuredProductId?: string | null, productIds: Array<string>, visibleProductIds: Array<string>, id: string, title: string } | null, paymentSettings: { __typename?: 'CommerceV2_PaymentSettings', currencyCode: CommerceV2_CurrencyCode } } | null };

export type GetActiveSaleIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveSaleIdQuery = { __typename?: 'Query', commerceV2_instance?: { __typename?: 'CommerceV2_Instance', id: string, activeSale?: { __typename?: 'CommerceV2_Sale', id: string } | null } | null };

export type ActiveSaleIdUpdatedSubscriptionVariables = Exact<{
  channelId: Scalars['ID'];
}>;


export type ActiveSaleIdUpdatedSubscription = { __typename?: 'Subscription', commerceV2_activeSaleUpdated?: { __typename?: 'CommerceV2_Instance', id: string, activeSale?: { __typename?: 'CommerceV2_Sale', id: string } | null } | null };

export type GetProductByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProductByIdQuery = { __typename?: 'Query', instance?: { __typename?: 'CommerceV2_Instance', id: string, activeSale?: { __typename?: 'CommerceV2_Sale', id: string, product?: { __typename?: 'CommerceV2_Product', id: string, available: boolean, title: string, priceRange: { __typename?: 'CommerceV2_PriceRange', maxVariantPrice: string, minVariantPrice: string }, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, preselectedVariant: { __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> }, variants: Array<{ __typename?: 'CommerceV2_ProductVariant', id: string, available: boolean, description?: string | null, price: string, title: string, featuredImage?: { __typename?: 'CommerceV2_Image', altText?: string | null, url: string } | null, images: Array<{ __typename?: 'CommerceV2_Image', altText?: string | null, url: string }>, options: Array<{ __typename?: 'CommerceV2_ProductOption', name: string, value: string }> }>, options: Array<{ __typename?: 'CommerceV2_ProductOptions', name: string, values: Array<string> }> } | null } | null } | null };

export type CreateCartMutationVariables = Exact<{
  items: Array<Target_CreateCartInput> | Target_CreateCartInput;
}>;


export type CreateCartMutation = { __typename?: 'Mutation', target_createCart: string };

export const BaseSaleFragmentDoc = gql`
    fragment BaseSale on CommerceV2_Sale {
  id
  title
}
    `;
export const BaseProductFragmentDoc = gql`
    fragment BaseProduct on CommerceV2_Product {
  id
  available
  title
}
    `;
export const PriceRangeFragmentDoc = gql`
    fragment PriceRange on CommerceV2_PriceRange {
  maxVariantPrice
  minVariantPrice
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on CommerceV2_Image {
  altText
  url
}
    `;
export const ProductOptionFragmentDoc = gql`
    fragment ProductOption on CommerceV2_ProductOption {
  name
  value
}
    `;
export const ProductVariantFragmentDoc = gql`
    fragment ProductVariant on CommerceV2_ProductVariant {
  id
  available
  description
  featuredImage {
    ...Image
  }
  images {
    ...Image
  }
  options {
    ...ProductOption
  }
  price
  title
}
    ${ImageFragmentDoc}
${ProductOptionFragmentDoc}`;
export const ProductOptionsFragmentDoc = gql`
    fragment ProductOptions on CommerceV2_ProductOptions {
  name
  values
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on CommerceV2_Product {
  ...BaseProduct
  priceRange {
    ...PriceRange
  }
  featuredImage {
    ...Image
  }
  preselectedVariant {
    ...ProductVariant
  }
  variants {
    ...ProductVariant
  }
  options {
    ...ProductOptions
  }
}
    ${BaseProductFragmentDoc}
${PriceRangeFragmentDoc}
${ImageFragmentDoc}
${ProductVariantFragmentDoc}
${ProductOptionsFragmentDoc}`;
export const SaleFragmentDoc = gql`
    fragment Sale on CommerceV2_Sale {
  ...BaseSale
  featuredProductId
  productIds
  products {
    ...Product
  }
  visibleProductIds
}
    ${BaseSaleFragmentDoc}
${ProductFragmentDoc}`;
export const PaymentSettingsFragmentDoc = gql`
    fragment PaymentSettings on CommerceV2_PaymentSettings {
  currencyCode
}
    `;
export const InstanceFragmentDoc = gql`
    fragment Instance on CommerceV2_Instance {
  id
  activeSale {
    ...Sale
  }
  paymentSettings {
    ...PaymentSettings
  }
}
    ${SaleFragmentDoc}
${PaymentSettingsFragmentDoc}`;
export const ProductHighlightFragmentDoc = gql`
    fragment ProductHighlight on CommerceV2_Product {
  ...BaseProduct
  priceRange {
    ...PriceRange
  }
  preselectedVariant {
    ...ProductVariant
  }
  featuredImage {
    ...Image
  }
}
    ${BaseProductFragmentDoc}
${PriceRangeFragmentDoc}
${ProductVariantFragmentDoc}
${ImageFragmentDoc}`;
export const GetActiveSaleHighlightsDocument = gql`
    query getActiveSaleHighlights {
  commerceV2_instance {
    id
    activeSale {
      ...BaseSale
      featuredProductId
      productIds
      products {
        ...ProductHighlight
      }
      visibleProductIds
    }
    paymentSettings {
      ...PaymentSettings
    }
  }
}
    ${BaseSaleFragmentDoc}
${ProductHighlightFragmentDoc}
${PaymentSettingsFragmentDoc}`;

/**
 * __useGetActiveSaleHighlightsQuery__
 *
 * To run a query within a React component, call `useGetActiveSaleHighlightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveSaleHighlightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveSaleHighlightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveSaleHighlightsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveSaleHighlightsQuery, GetActiveSaleHighlightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveSaleHighlightsQuery, GetActiveSaleHighlightsQueryVariables>(GetActiveSaleHighlightsDocument, options);
      }
export function useGetActiveSaleHighlightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveSaleHighlightsQuery, GetActiveSaleHighlightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveSaleHighlightsQuery, GetActiveSaleHighlightsQueryVariables>(GetActiveSaleHighlightsDocument, options);
        }
export type GetActiveSaleHighlightsQueryHookResult = ReturnType<typeof useGetActiveSaleHighlightsQuery>;
export type GetActiveSaleHighlightsLazyQueryHookResult = ReturnType<typeof useGetActiveSaleHighlightsLazyQuery>;
export type GetActiveSaleHighlightsQueryResult = Apollo.QueryResult<GetActiveSaleHighlightsQuery, GetActiveSaleHighlightsQueryVariables>;
export const ActiveSaleHighlightsUpdatedDocument = gql`
    subscription activeSaleHighlightsUpdated($channelId: ID!) {
  commerceV2_activeSaleUpdated(channelId: $channelId) {
    id
    activeSale {
      ...BaseSale
      featuredProductId
      productIds
      visibleProductIds
    }
    paymentSettings {
      ...PaymentSettings
    }
  }
}
    ${BaseSaleFragmentDoc}
${PaymentSettingsFragmentDoc}`;

/**
 * __useActiveSaleHighlightsUpdatedSubscription__
 *
 * To run a query within a React component, call `useActiveSaleHighlightsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActiveSaleHighlightsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveSaleHighlightsUpdatedSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useActiveSaleHighlightsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ActiveSaleHighlightsUpdatedSubscription, ActiveSaleHighlightsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ActiveSaleHighlightsUpdatedSubscription, ActiveSaleHighlightsUpdatedSubscriptionVariables>(ActiveSaleHighlightsUpdatedDocument, options);
      }
export type ActiveSaleHighlightsUpdatedSubscriptionHookResult = ReturnType<typeof useActiveSaleHighlightsUpdatedSubscription>;
export type ActiveSaleHighlightsUpdatedSubscriptionResult = Apollo.SubscriptionResult<ActiveSaleHighlightsUpdatedSubscription>;
export const GetActiveSaleIdDocument = gql`
    query getActiveSaleId {
  commerceV2_instance {
    id
    activeSale {
      id
    }
  }
}
    `;

/**
 * __useGetActiveSaleIdQuery__
 *
 * To run a query within a React component, call `useGetActiveSaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveSaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveSaleIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveSaleIdQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveSaleIdQuery, GetActiveSaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveSaleIdQuery, GetActiveSaleIdQueryVariables>(GetActiveSaleIdDocument, options);
      }
export function useGetActiveSaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveSaleIdQuery, GetActiveSaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveSaleIdQuery, GetActiveSaleIdQueryVariables>(GetActiveSaleIdDocument, options);
        }
export type GetActiveSaleIdQueryHookResult = ReturnType<typeof useGetActiveSaleIdQuery>;
export type GetActiveSaleIdLazyQueryHookResult = ReturnType<typeof useGetActiveSaleIdLazyQuery>;
export type GetActiveSaleIdQueryResult = Apollo.QueryResult<GetActiveSaleIdQuery, GetActiveSaleIdQueryVariables>;
export const ActiveSaleIdUpdatedDocument = gql`
    subscription activeSaleIdUpdated($channelId: ID!) {
  commerceV2_activeSaleUpdated(channelId: $channelId) {
    id
    activeSale {
      id
    }
  }
}
    `;

/**
 * __useActiveSaleIdUpdatedSubscription__
 *
 * To run a query within a React component, call `useActiveSaleIdUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActiveSaleIdUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveSaleIdUpdatedSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useActiveSaleIdUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ActiveSaleIdUpdatedSubscription, ActiveSaleIdUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ActiveSaleIdUpdatedSubscription, ActiveSaleIdUpdatedSubscriptionVariables>(ActiveSaleIdUpdatedDocument, options);
      }
export type ActiveSaleIdUpdatedSubscriptionHookResult = ReturnType<typeof useActiveSaleIdUpdatedSubscription>;
export type ActiveSaleIdUpdatedSubscriptionResult = Apollo.SubscriptionResult<ActiveSaleIdUpdatedSubscription>;
export const GetProductByIdDocument = gql`
    query getProductById($id: ID!) {
  instance: commerceV2_instance {
    id
    activeSale {
      id
      product(id: $id) {
        ...Product
      }
    }
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useGetProductByIdQuery__
 *
 * To run a query within a React component, call `useGetProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProductByIdQuery, GetProductByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, options);
      }
export function useGetProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductByIdQuery, GetProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, options);
        }
export type GetProductByIdQueryHookResult = ReturnType<typeof useGetProductByIdQuery>;
export type GetProductByIdLazyQueryHookResult = ReturnType<typeof useGetProductByIdLazyQuery>;
export type GetProductByIdQueryResult = Apollo.QueryResult<GetProductByIdQuery, GetProductByIdQueryVariables>;
export const CreateCartDocument = gql`
    mutation CreateCart($items: [Target_CreateCartInput!]!) {
  target_createCart(items: $items)
}
    `;
export type CreateCartMutationFn = Apollo.MutationFunction<CreateCartMutation, CreateCartMutationVariables>;

/**
 * __useCreateCartMutation__
 *
 * To run a mutation, you first call `useCreateCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCartMutation, { data, loading, error }] = useCreateCartMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useCreateCartMutation(baseOptions?: Apollo.MutationHookOptions<CreateCartMutation, CreateCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCartMutation, CreateCartMutationVariables>(CreateCartDocument, options);
      }
export type CreateCartMutationHookResult = ReturnType<typeof useCreateCartMutation>;
export type CreateCartMutationResult = Apollo.MutationResult<CreateCartMutation>;
export type CreateCartMutationOptions = Apollo.BaseMutationOptions<CreateCartMutation, CreateCartMutationVariables>;